var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockplayerFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H5v16h14V8h-4V4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0120.007 22H3.993A1 1 0 013 21.008V2.992zM13 12v4h-2v-4H8l4-4 4 4h-3z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+PHBhdGggZD0iTTE1IDRINXYxNmgxNFY4aC00VjR6TTMgMi45OTJDMyAyLjQ0NCAzLjQ0NyAyIDMuOTk5IDJIMTZsNSA1djEzLjk5M0ExIDEgMCAwIDEgMjAuMDA3IDIySDMuOTkzQTEgMSAwIDAgMSAzIDIxLjAwOFYyLjk5MnpNMTMgMTJ2NGgtMnYtNEg4bDQtNCA0IDRoLTN6Ii8+PC9zdmc+";
export { SvgBlockplayerFileUpload as ReactComponent };